import { createAction, handleActions } from 'redux-actions'

const setSorting = createAction('SCREENS/RAMSSIGNINGS/SET_SORTING')

const defaultState = {
  columnKey: null,
  descending: false,
}

const reducer = handleActions(
  {
    [setSorting]: (state, action) => ({ ...state, ...action.payload }),
  },
  defaultState,
)

export { setSorting, reducer }
